// extracted by mini-css-extract-plugin
export var errorMessage = "InfoMessage-module--errorMessage--fd6e2";
export var errorMessageWrapper = "InfoMessage-module--errorMessageWrapper--92dc7 typography-module--paragraphSans--0fb30";